import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
// material-ui
import { withStyles } from "@material-ui/styles";
// components
import CustomersList from "components/CustomersList";
import FormCustomer from "components/FormCustomer";
// reactor
import Page from "components/Page";
import { removeURLParameter, updateURLParameter } from "helpers";
import PropTypes from "prop-types";
import React from "react";
// styles
import styles from "./styles";

class WrapperCustomerPage extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    loading: PropTypes.bool,
    customers: PropTypes.array,
    createCustomer: PropTypes.func,
    deleteCustomer: PropTypes.func,
    updateCustomer: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedCustomer: undefined,
      formCustomerOpen: urlParams.newCustomer,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.urlParams.newCustomer) {
      this.setState({ formCustomerOpen: true });
    }
  }

  getStepContent() {
    const { index } = this.state;
    const { customers, history } = this.props;

    switch (index) {
      case 0:
        return (
          <CustomersList
            history={history}
            customers={customers}
            onSelect={(selectedCustomer) =>
              this.setState({
                selectedCustomer,
                formCustomerOpen: true,
              })
            }
          />
        );
      default:
    }

    return [];
  }

  render() {
    const {
      classes,
      history,
      loading,
      createCustomer,
      deleteCustomer,
      updateCustomer,
      refresh,
    } = this.props;

    const { index, selectedCustomer, formCustomerOpen } = this.state;

    return (
      <Page
        helmet="All Customers"
        loadingMessage={"Loading Customers"}
        loading={loading}
        tabs={
          <Tabs
            value={index}
            onChange={(e, v) => {
              this.setState({
                index: v,
              });
              history.push({
                search: updateURLParameter("index", v),
              });
            }}
            indicatorColor="secondary"
            textColor="secondary"
            variant="scrollable"
            scrollButtons="auto"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            <Tab
              label="All"
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
              }}
            />
          </Tabs>
        }
      >
        {this.getStepContent()}
        <FormCustomer
          open={formCustomerOpen}
          customer={selectedCustomer}
          close={() => {
            this.setState({
              formCustomerOpen: false,
            });
            history.push({ search: removeURLParameter("newCustomer") });
            setTimeout(
              () =>
                this.setState({
                  selectedCustomer: undefined,
                }),
              200
            );
          }}
          createCustomer={createCustomer}
          deleteCustomer={deleteCustomer}
          updateCustomer={updateCustomer}
          refresh={refresh}
        />
      </Page>
    );
  }
}
export default withStyles(styles)(WrapperCustomerPage);
